import React from 'react';
import { Badge } from '.';
import { useEssentials } from '../../contexts/essentials-context';
import { Box, Text } from '@wix/design-system';

interface WixChoiceBadgeProps {
  showBorder?: boolean;
  size?: 'tiny' | 'small' | 'medium';
}

export function WixChoiceBadge({
  showBorder,
  size = 'tiny',
}: WixChoiceBadgeProps) {
  const { t } = useEssentials();

  return (
    <Badge
      skin="neutralStandard"
      dataHook="wix-choice-badge"
      uppercase={false}
      showBorder={showBorder}
      size={size}
      tooltipContent={
        <Box direction="vertical" gap="6px">
          {/* @ts-expect-error wds types are incompatible */}
          <Text size="small" weight="bold" skin="light">
            {t('wix.choice.badge')}
          </Text>
          {/* @ts-expect-error wds types are incompatible */}
          <Text size="small" weight="thin" skin="light">
            {t('wix.choice.badge.tooltip')}
          </Text>
        </Box>
      }
    >
      <Box fontSize={size === 'medium' ? 'small' : 'tiny'}>
        {t('wix.choice.badge')}
      </Box>
    </Badge>
  );
}
